export default __webpack_public_path__ + "static/media/git.29942dff.jpg";